import type { GridSortDirection } from '@mui/x-data-grid-pro';

import type { SortedField } from '~/shared/data-contract/common';

const getSortSign = (sort: GridSortDirection): string => (sort === 'desc' ? '-' : '');

export const getSortParams = (sortedFields: readonly SortedField[]): string =>
    sortedFields.map((curItem) => `${getSortSign(curItem.direction)}${curItem.field}`).join(',');
